<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dodajte novega klienta:
    </h2>

    <CompanyClientForm
      @save="save"
      @cancel="cancel"
      :countryList="countryList"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import CompanyClientForm from '@/components/CompanyClientForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    CompanyClientForm
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      countryList: []
    }
  },
  methods: {
    ...mapActions('clients', ['saveItem']),
    ...mapActions('companies', ['getCountries']),
    save ({ data }) {
      saveItem(data, 'MyCompanyClients', this)
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyClients' })
    }
  },
  created () {
    this.getCountries()
      .then(countries => {
        this.countryList = countries
        this.asyncDataStatus_fetched()
      })
  }
}
</script>
